<template>
  <div>
    <denormalized-child
      v-for="(child, index) in value"
      v-model="value[index]"
      :key="index"
      :field="field"
      :parent-field="field"
    />
    <v-btn
      v-if="field.canEdit"
      @click="addChild"
    >
      New room
    </v-btn>
  </div>
</template>

<script>
import DenormalizedChild from './DenormalizedChild'

export default {
  name: 'DenormalizedChildren',

  components: {
    DenormalizedChild
  },

  data () {
    return {
      module: {},
      linkOptions: {},
      loading: true
    }
  },

  props: {
    field: {
      type: Object,
      default: () => {
        return {}
      }
    },

    value: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  methods: {
    addChild () {
      this.value.push({})
    }
  }
}
</script>
